// extracted by mini-css-extract-plugin
export var actionText = "_m2-4";
export var container = "_m2-0";
export var leftSection = "_m2-1";
export var rightSection = "_m2-2";
export var settingsButton = "_m2-6";
export var settingsIcon = "_m2-7";
export var shortcut = "_m2-5";
export var shortcutGroup = "_m2-3";